import { stateOptions } from '../commonStateTaxData';

export const basicInfoQuestions = [
  {
    id: 'employee_first_name_middle_initial',
    title: 'First name and initial',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Permanent address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'marital_status',
    title: 'Marital status',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single or married but legally separated or spouse is a nonresident alien',
      },
      {
        codeValue: 'married',
        shortName: 'Married',
      },
      {
        codeValue: 'married_at_single_rate',
        shortName: 'Married, but withhold at higher single rate',
      },
    ],
  },
];

export const stateOfDomicileQuestion = [
  {
    id: 'state_of_domicile',
    title: 'My state of domicile is:',
    question_type: 'dropdown',
    is_required: true,
    options: stateOptions,
  },
];

export const americanIndianQuestions = [
  {
    id: 'reservation_name',
    title: 'Enter the reservation name:',
    question_type: 'short_text',
    is_required: true,
  },
  {
    id: 'cdib_num',
    title: 'Enter your Certificate of Degree of Indian Blood (CDIB)/Enrollment number:',
    question_type: 'short_text',
    is_required: true,
  },
];

export const allowancesQuestions = [
  {
    id: 'dependents',
    title: 'Enter the number of dependents (other than your spouse or yourself) you will claim on your tax return.',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
];

export const additionalWithholdingQuestion = [
  {
    id: 'additional_withholding',
    title: 'Additional Minnesota withholding you want deducted each pay period',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
